export default {
  openRequest: {
    id: 'asp_seller_action_bar_open_claim',
    defaultMessage: 'Open service request',
  },
}
